import { formatDay, formatEatDate, formatEatTime, formatPhone, parseIsoDay } from '@wodi/domain';

/** `2026-09-22` as `22 Sep 2026` (DESIGN.md §9). */
export function formatIsoDate(iso: string): string {
  const day = parseIsoDay(iso);
  return day.ok ? formatDay(day.value) : iso;
}

/** An instant as `22 Sep 2026 14:05`, East Africa Time. */
export function formatInstant(iso: string): string {
  const instant = new Date(iso);
  return `${formatEatDate(instant)} ${formatEatTime(instant)}`;
}

export function formatDateOnly(iso: string): string {
  return formatEatDate(new Date(iso));
}

export function formatTimeOnly(iso: string): string {
  return formatEatTime(new Date(iso));
}

/** A stored phone (2547…) as `0712 345 678`; anything else is shown as it is. */
export function formatStoredPhone(msisdn: string): string {
  try {
    return formatPhone(msisdn);
  } catch {
    return msisdn;
  }
}
